export const ModuleNames = {
    Events: 'Events',
    Tasks: 'Tasks',
    Peoples: 'Peoples',
    Companies: 'Companies',
    Users: 'Users',
    ExternalRelation: 'ExternalRelation'
};
export const ModuleRequestNames = {
    [ModuleNames.Events]: 'events',
    [ModuleNames.Tasks]: 'tasks',
    [ModuleNames.Peoples]: 'peoples',
    [ModuleNames.Companies]: 'companies',
    [ModuleNames.Users]: 'users',
    [ModuleNames.ExternalRelation]: 'externalRelation',
};
